<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">{{ t('Notifications') }}</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('Notifications') }}</h3>
        <p></p>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-md-7 col-lg-6">
        <!-- Navegador não suporta -->
        <div v-if="!supported" class="card border-0 shadow-sm text-center p-5">
          <div class="mb-3">
            <span class="d-inline-flex align-items-center justify-content-center rounded-circle bg-warning text-white" style="width:72px;height:72px;">
              <i class="bx bx-error" style="font-size:34px;"></i>
            </span>
          </div>
          <h4 class="mb-2">Navegador incompatível</h4>
          <p class="text-muted mb-0">
            Seu navegador não suporta notificações push.<br>
            Tente usando Chrome, Edge ou Firefox atualizados.
          </p>
        </div>
        <!-- Suportado -->
        <div v-else>
          <!-- Estado: BLOQUEADO -->
          <div v-if="permission === 'denied'" class="card border-0 shadow-sm text-center p-5">
            <div class="mb-3">
              <span class="d-inline-flex align-items-center justify-content-center rounded-circle bg-danger text-white" style="width:72px;height:72px;">
                <i class="bx bx-bell-off" style="font-size:34px;"></i>
              </span>
            </div>
            <div class="badge badge-danger mb-3 py-2 font-size-18">Bloqueada</div>
            <p class="text-muted mb-4">
              Você bloqueou as notificações para este site. Para ativar,
              clique no ícone de cadeado na barra de endereços do navegador
              e permita as notificações.
            </p>
            <div class="alert alert-light border mb-0 text-left">
              <strong>Como desbloquear:</strong>
              <ol class="mb-0 mt-1 pl-3">
                <li>Clique no cadeado na barra de endereço</li>
                <li>Vá em <strong>Configurações do site</strong></li>
                <li>Altere <strong>Notificações</strong> para <em>Permitir</em></li>
                <li>Recarregue a página</li>
              </ol>
            </div>
          </div>
          <!-- Estado: ATIVO -->
          <div v-else-if="permission === 'granted' && subscribed" class="card border-0 shadow-sm text-center p-5">
            <div class="mb-3">
              <span class="d-inline-flex align-items-center justify-content-center rounded-circle bg-success text-white" style="width:72px;height:72px;">
                <i class="bx bx-bell" style="font-size:34px;"></i>
              </span>
            </div>
            <div class="badge badge-success mb-3 py-2 font-size-18">Ativo</div>
            <p class="text-muted mb-4">
              Você receberá avisos sobre sua conta, pagamentos, eventos e atualizações
              diretamente neste navegador.
            </p>
            <button
              class="btn btn-outline-danger btn-lg px-4"
              :disabled="loading"
              @click="disablePush"
            >
              <span v-if="loading">Processando...</span>
              <span v-else>Desativar notificações</span>
            </button>
          </div>
          <!-- Estado: INATIVO / PADRÃO -->
          <div v-else class="card border-0 shadow-sm text-center p-5">
            <div class="mb-3">
              <span class="d-inline-flex align-items-center justify-content-center rounded-circle bg-secondary text-white" style="width:72px;height:72px;">
                <i class="bx bx-bell-plus" style="font-size:34px;"></i>
              </span>
            </div>
            <div class="badge badge-secondary mb-3 py-2 font-size-18">Inativo</div>
            <p class="text-muted mb-4">
              Receba avisos importantes sobre sua conta, pagamentos, eventos
              e atualizações diretamente neste navegador, sem precisar abrir o aplicativo.
            </p>
            <button
              class="btn btn-primary btn-lg px-4"
              :disabled="loading"
              @click="enablePush"
            >
              <span v-if="loading">Processando...</span>
              <span v-else>Ativar notificações</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export default {
  components: { Layout },
  data() {
    return {
      supported: "serviceWorker" in navigator && "PushManager" in window,
      permission: typeof Notification !== "undefined" ? Notification.permission : "default",
      subscribed: false,
      loading: false,
    };
  },
  async mounted() {
    if (this.supported) {
      await this.checkSubscription();
    }
  },
  methods: {
    async checkSubscription() {
      try {
        const registration = await navigator.serviceWorker.ready;
        const existing = await registration.pushManager.getSubscription();
        this.subscribed = !!existing;
      } catch (e) {
        this.subscribed = false;
      }
    },

    async enablePush() {
      if (!this.supported) return;
      this.loading = true;

      try {
        // 1. Pedir permissão se ainda não foi concedida
        if (this.permission !== "granted") {
          let result;
          try {
            result = await Notification.requestPermission();
          } catch (e) {
            // Safari usa callback em vez de Promise
            result = await new Promise((resolve) => Notification.requestPermission(resolve));
          }
          this.permission = result;
          if (result !== "granted") {
            this.$toast.warning("Permissão negada. Autorize as notificações no seu navegador.");
            return;
          }
        }

        // 2. Aguardar service worker estar pronto
        let registration;
        try {
          registration = await Promise.race([
            navigator.serviceWorker.ready,
            new Promise((_, reject) => setTimeout(() => reject(new Error("SW timeout")), 10000)),
          ]);
        } catch (e) {
          this.$toast.error("Serviço de notificações não iniciou. Recarregue a página e tente novamente.");
          return;
        }

        // 3. Cancelar assinatura anterior se existir (garante chave VAPID atualizada)
        const existing = await registration.pushManager.getSubscription();
        if (existing) {
          await existing.unsubscribe();
        }

        // 4. Verificar chave pública
        const publicKey = process.env.VUE_APP_VAPID_PUBLIC_KEY;
        if (!publicKey) {
          this.$toast.error("Configuração de notificações ausente. Contate o suporte.");
          return;
        }

        // 5. Criar nova assinatura no navegador
        let subscription;
        try {
          subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(publicKey),
          });
        } catch (e) {
          this.$toast.error("Não foi possível criar a assinatura de notificação. Verifique se o site usa HTTPS.");
          return;
        }

        // 6. Registrar no servidor
        try {
          await api.post("webpush/subscribe", {
            subscription: subscription.toJSON(),
          });
        } catch (e) {
          await subscription.unsubscribe();
          this.$toast.error("Erro ao registrar a assinatura no servidor. Tente novamente.");
          return;
        }

        this.subscribed = true;
        this.$toast.success("Notificações ativadas com sucesso!");
      } finally {
        this.loading = false;
      }
    },

    async disablePush() {
      if (!this.supported) return;
      this.loading = true;

      try {
        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.getSubscription();
        if (subscription) {
          await subscription.unsubscribe();
        }

        try {
          await api.delete("webpush/unsubscribe");
        } catch (e) {
          // ignora erro de rede, a assinatura local já foi removida
        }

        this.subscribed = false;
        this.$toast.success("Notificações desativadas.");
      } catch (e) {
        this.$toast.error("Não foi possível desativar as notificações. Tente novamente.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
